export const ICON_HEIGHT = 50;
export const ICON_WIDTH = 50;

export interface ColorIconProps {
  size?: number | string;
  height?: number | string;
  width?: number | string;
  className?: string;
}

export interface IconProps extends ColorIconProps {
  fill?: string;
}

export function iconSize(
  props: {
    size?: string | number;
    width?: string | number;
    height?: string | number;
  },
  baseWidth: number,
  baseHeight: number
) {
  return {
    width:
      props.width ??
      props.size ??
      (props.height && typeof props.height === 'number'
        ? (props.height * baseWidth) / baseHeight
        : baseWidth),
    height:
      props.height ??
      props.size ??
      (props.width && typeof props.width === 'number'
        ? (props.width * baseHeight) / baseWidth
        : baseHeight),
  };
}
